import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import PermisoFormSections from "./PermisoFormSections.js";

class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            padre: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            padre: data.padre_id,
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.permisos.delete}
                postUrl={api.usuarios.permisos.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Permiso ha sido eliminado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Permiso"}
                buttonIcon={"fa fa-trash fa-lg"}
                
                saveButton={true}
                closeButton={true}
                buttonClass={"btn-danger"}
                danger={true}
                saveButtonLabel={"Eliminar"}
                className={"ui-modal-dialog ui-modal-md"}
                onGotData={(data) => this.setSelects(data)}
            >
                <div className="ui-form">
                    <div className="ui-alert ui-alert-danger">
                        <i className="ti ti-trash" aria-hidden="true"></i>
                        Se eliminará el permiso seleccionado.
                    </div>
                    <PermisoFormSections disabled={true} padre={this.state.padre} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Permisos/Delete.js